<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
      :opacity="0.99"
      :width="150"
      :height="150">
    </loading>
    <main id="content" v-if="vehicle && this.$route.query.print !== 'true'">
      <section id="carDetail-page">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-12 col-lg-auto">
              <a href="javascript:;" @click="goBack('#inventory')" class="btn btn-block btn-primary back-btn buttonBackgroundBorder">
                <i class="icon-arrow-left"></i>{{ $t('Regresar al inventario') }}
              </a>
            </div>
            <div class="col-auto d-none d-lg-block">
              <a href="javascript:;" @click="goBack('#inventory')" class="close-btn buttonElement"><i class="icon-close"></i></a>
            </div>
          </div>
          <hr class="my-2">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="javascript:;" @click="goBack('#topbar')" class="hoverElement buttonElement">{{ $t('Inicio') }}</a></li>
              <li class="breadcrumb-item"><a href="javascript:;" @click="goBack('#inventory')" class="hoverElement buttonElement">{{ $t('Inventario') }}</a></li>
              <li class="breadcrumb-item active" aria-current="page">{{ $t('Detalles') }}</li>
            </ol>
          </nav>
          <div class="row">
            <div class="col-12">
              <div class="mb-5">
                <div class="row" v-if="vehicle.photos.length">
                  <div class="col-12 col-lg-7">
                    <flickity id="galleryDetail" ref="flickity" :options="flickityOptions">
                      <div class="img" v-for="(photo, index) in vehicle.photos" :key="index">
                        <img :data-flickity-lazyload="photo.url">
                      </div>
                    </flickity>
                  </div>
                  <div class="col-12 col-md d-none d-lg-block">
                    <div id="galleryThumbs">
                      <li v-for="(photo, index) in vehicle.photos" :key="index" :class="{ active : galleryIndex === index }" class="beforeBorderBot">
                        <button @click="galleryThumb(index)"><img :src="photo.url"></button>
                      </li>
                    </div>
                  </div>
                </div>
                <h2 class="cartitle text-uppercase mt-4 mb-3">{{ vehicle.make }} {{ vehicle.model }} {{ vehicle.exterior_generic_color }} {{ vehicle.year }}</h2>
                <div class="row">
                  <div class="col-12 col-lg-4">
                    <ul class="specs-list">
                      <li><span>{{ $t('Precio') }}:</span> {{ vehiclePrice ? `$${vehiclePrice}` : `${$t('Llame Ahora')}` }}{{ vehicle.selling_price.payment.value ? ` | $${vehicle.selling_price.payment.value|numFormat}` : '' }}</li>
                      <li><span>{{ $t('Condición') }}:</span> {{ vehicle.condition|condition }}</li>
                      <li><span>{{ $t('Estilo') }}:</span> {{ vehicle.style }}</li>
                      <li><span>{{ $t('Año') }}:</span> {{ vehicle.year }}</li>
                    </ul>
                  </div>
                  <div class="col-12 col-lg-4">
                    <ul class="specs-list">
                      <li><span>{{ $t('Millaje') }}:</span> {{ vehicle.mileage|numFormat }}</li>
                      <li><span>{{ $t('Color') }}:</span> {{ vehicle.exterior_generic_color }}</li>
                      <li><span>{{ $t('Transmisión') }}:</span> {{ vehicle.transmission_description }}</li>
                      <li><span>VIN:</span> {{ vehicle.vin }}</li>
                    </ul>
                  </div>
                  <div class="col-12 col-lg-4">
                    <ul class="specs-list">
                      <li><span>{{ $t('Descripción') }}:</span> <p v-html="vehicle.description"></p></li>
                    </ul>
                  </div>
                </div>
                <div class="mpg-text">{{ vehicle.city_miles_per_gallon }}<i class="icon-mpg"></i> {{ vehicle.highway_miles_per_gallon }}</div>
                <br>
                <div class="row">
                  <div class="col-12 col-md mb-2"><a href="javascript:;" @click="setTabID('schedule-testdrive')" v-scroll-to="{ el: '#schedule-testdrive', offset: -180 }" class="btn btn-primary btn-block i-lg scrollTo buttonBackgroundBorder"><i class="icon-testdrive mr-2"></i> {{ $t('Agendar test-drive') }}</a></div>
                  <div class="col-12 col-md mb-2"><a href="javascript:;" @click="printPage" class="btn btn-primary btn-block i-lg buttonBackgroundBorder"><i class="icon-print mr-2"></i>{{ $t('Imprimir') }}</a> </div>
                  <div class="col-12 col-md mb-2"><a href="javascript:;" @click="setTabID('view-availability')" v-scroll-to="{ el: '#view-availability', offset: -180 }" class="btn btn-primary btn-block i-lg buttonBackgroundBorder"><i class="icon-calendar mr-2"></i> {{ $t('Ver disponibilidad') }}</a></div>
                  <div class="col-12 col-md mb-2"><a href="javascript:;" @click="setTabID('finance-tab')" v-scroll-to="{ el: '#finance-tab', offset: -180 }" class="btn btn-primary btn-block i-lg scrollTo buttonBackgroundBorder"><i class="icon-finance mr-2"></i> {{ $t('Financiamiento') }}</a></div>
                </div>

              </div>

              <div class="mb-5">
                <h2 class="title text-center text-uppercase mt-4 mb-3 beforeBorderTop">{{ $t('ESPECIFICACIONES') }}</h2>
                <div class="sepcs-block" v-if="equipments.installed.length > 0">
                  <div class="head-specs">
                    <i class="icon-specs-installed"></i>
                    <h2>{{ $t('Equipos') }} <span>††</span></h2>
                  </div>
                  <ul class="check-list">
                    <li v-for="(equipment, index) in equipments.installed" :key="index" class="beforeColor">{{ equipment.description }}</li>
                  </ul>
                </div>
                <div class="sepcs-block" v-if="equipments.mechanical.length > 0">
                  <div class="head-specs">
                    <i class="icon-specs-mechanical"></i>
                    <h2>{{ $t('Mecánica') }} <span>††</span></h2>
                  </div>
                  <ul class="check-list">
                    <li v-for="(equipment, index) in equipments.mechanical" :key="index" class="beforeColor">{{ equipment.description }}</li>
                  </ul>
                </div>
                <div class="sepcs-block" v-if="equipments.safety.length > 0">
                  <div class="head-specs">
                    <i class="icon-specs-safety"></i>
                    <h2>{{ $t('Seguridad') }} <span>††</span></h2>
                  </div>
                  <ul class="check-list">
                    <li v-for="(equipment, index) in equipments.safety" :key="index" class="beforeColor">{{ equipment.description }}</li>
                  </ul>
                </div>
                <div class="sepcs-block" v-if="equipments.exterior.length > 0">
                  <div class="head-specs">
                    <i class="icon-specs-exterior"></i>
                    <h2>{{ $t('Exterior') }} <span>††</span></h2>
                  </div>
                  <ul class="check-list">
                    <li v-for="(equipment, index) in equipments.exterior" :key="index" class="beforeColor">{{ equipment.description }}</li>
                  </ul>
                </div>
                <div class="sepcs-block" v-if="equipments.interior.length > 0">
                  <div class="head-specs">
                    <i class="icon-specs-interior"></i>
                    <h2>{{ $t('Interior') }} <span>††</span></h2>
                  </div>
                  <ul class="check-list">
                    <li v-for="(equipment, index) in equipments.interior" :key="index" class="beforeColor">{{ equipment.description }}</li>
                  </ul>
                </div>
                <div class="sepcs-block" v-if="equipments.entertainment.length > 0">
                  <div class="head-specs">
                    <i class="icon-specs-entertainment"></i>
                    <h2>{{ $t('Entretenimiento') }} <span>††</span></h2>
                  </div>
                  <ul class="check-list">
                    <li v-for="(equipment, index) in equipments.entertainment" :key="index" class="beforeColor">{{ equipment.description }}</li>
                  </ul>
                </div>
                <div class="sepcs-block" v-if="equipments.specs.length > 0">
                  <div class="head-specs">
                    <i class="icon-specs-tech"></i>
                    <h2>{{ $t('Especificaciones Técnicas') }} <span>††</span></h2>
                  </div>
                  <ul class="check-list">
                    <li v-for="(equipment, index) in equipments.specs" :key="index" class="beforeColor">{{ equipment.description }}</li>
                  </ul>
                </div>
              </div>


            <section id="formSection" class="mt-5">
              <div class="container p-0">
                <nav class="tabNav">
                  <a href="javascript:;" :class="{ 'formElement active': currentTabID == 'schedule-testdrive' || currentTabID == 'contact-tab', formElement: currentTabID == 'schedule-testdrive'}" @click="changeTabID('schedule-testdrive');"><i class="icon-testdrive"></i><span>{{ $t('Prueba de manejo').toUpperCase() }}</span></a>
                  <a href="javascript:;" :class="{ 'formElement active': currentTabID == 'view-availability', formElement: currentTabID == 'view-availability' }" @click="changeTabID('view-availability');"><i class="icon-calendar"></i><span>{{ $t('Ver disponibilidad').toUpperCase() }}</span></a>
                  <a href="javascript:;" :class="{ 'formElement active': currentTabID == 'finance-tab', formElement: currentTabID == 'finance-tab' }" @click="changeTabID('finance-tab');"><i class="icon-finance"></i><span>{{ $t('Financiamiento').toUpperCase() }}</span></a>
                </nav>
                <div class="tabsContent px-3">
                  <form id="schedule-testdrive" :class="{ tab: true, 'd-block': currentTabID == 'schedule-testdrive' || currentTabID == 'contact-tab' }" v-on:submit.prevent="validateForm('testDrive')" data-vv-scope="testDrive">
                    <h2 class="title text-center text-uppercase my-4 beforeBorderTop">{{ $t('POR FAVOR LLENE SU INFORMACIÓN') }}:</h2>
                    <div class="row">
                      <div class="form-group col-12 col-lg-4">
                        <label>{{ $t('Nombre').toUpperCase() }} *</label>
                        <input v-model="testDrive.name" name="testDrive.name" v-validate="'required'" type="text" class="form-control form-control-lg">
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('testDrive.name')">{{ $t('El campo nombre es requerido') }}</span>
                      </div>
                      <div class="form-group col-12 col-lg-4">
                        <label>{{ $t('Apellido').toUpperCase() }} *</label>
                        <input v-model="testDrive.lastname" name="testDrive.lastname" v-validate="'required'" type="text" class="form-control form-control-lg">
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('testDrive.lastname')">{{ $t('El campo apellido es requerido') }}</span>
                      </div>
                      <div class="form-group col-12 col-lg-4">
                        <label>{{ $t('Teléfono').toUpperCase() }} *</label>
                        <masked-input v-model="testDrive.phone" mask="(111) 111-1111" type="tel" name="testDrive.phone" v-validate="'required'" class="form-control form-control-lg"/>
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="testDrive.submitted && errors.has('testDrive.phone')">{{ $t('El campo teléfono es requerido') }}</span>
                      </div>
                      <div class="form-group col-12 col-lg-4">
                        <label>{{ $t('Correo Electrónico').toUpperCase() }}</label>
                        <input v-model="testDrive.email" name="testDrive.email" v-validate="'required'" type="text" class="form-control form-control-lg">
                      </div>
                      <div class="form-group col-12 col-lg-4">
                        <label>{{ $t('Fecha y Hora').toUpperCase() }}*</label>
                        <flat-pickr v-model="testDrive.datetime"
                                v-validate="'required'"
                                :config="config"
                                class="form-control form-control-lg"
                                placeholder="Select date"
                                name="testDrive.datetime">
                        </flat-pickr>
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('testDrive.datetime')">{{ $t('El campo Fecha y Hora es requerido') }}</span>
                        <!-- <input v-model="testDrive.datetime" name="testDrive.datetime" v-validate="'required'" type="text" class="form-control form-control-lg"> -->
                      </div>
                      <div class="form-group col-12 col-lg-8">
                        <label>{{ $t('INTERESADO EN') }}</label>
                        <input v-model="testDrive.vehicle" name="testDrive.vehicle" v-validate="'required'" type="text" class="form-control form-control-lg" disabled>
                      </div>
                      <div class="form-group col-12 col-lg-12">
                        <label>{{ $t('MENSAJE') }}</label>
                        <textarea v-model="testDrive.message" name="testDrive.message" v-validate="'required'" class="form-control form-control-lg" rows="1"></textarea>
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('testDrive.message')">{{ $t('El campo mensaje es requerido') }}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12">
                        <div class="captcha formBorder">
                          <h3 class="formElement">{{ $t('Comprobar que eres humano') }}:</h3>
                          <label><input v-model="testDrive.human" name="testDrive.human" v-validate="'required'" type="checkbox"> {{ $t('Marcar esta casilla para corroborar que es humano') }}</label>
                            <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('testDrive.human')">{{ $t('Debes confirmar que eres humano') }}</span>
                        </div>
                      </div>
                      <div class="col-12">
                        <p class="text-success" v-if="testDrive.responseMessage">{{ $t(testDrive.responseMessage) }}.</p>
                        <button type="submit" class="btn btn-primary i-lg formBackgroundBorder"><i class="icon-send mr-2"></i>
                          <strong>{{ $t('Enviar') }}</strong></button>
                      </div>
                    </div>
                  </form>
                  <form id="view-availability" :class="{ tab: true, 'd-block': currentTabID == 'view-availability' }" v-on:submit.prevent="validateForm('viewAvailability')" data-vv-scope="viewAvailability">
                    <h2 class="title text-center text-uppercase my-4 beforeBorderTop">{{ $t('POR FAVOR LLENE SU INFORMACIÓN') }}:</h2>
                    <div class="row">
                      <div class="form-group col-12 col-lg-4">
                        <label>{{ $t('Nombre').toUpperCase() }} *</label>
                        <input v-model="viewAvailability.name" name="viewAvailability.name" v-validate="'required'" type="text" class="form-control form-control-lg">
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('viewAvailability.name')">{{ $t('El campo nombre es requerido') }}</span>
                      </div>
                      <div class="form-group col-12 col-lg-4">
                        <label>{{ $t('Apellido').toUpperCase() }} *</label>
                        <input v-model="viewAvailability.lastname" name="viewAvailability.lastname" v-validate="'required'" type="text" class="form-control form-control-lg">
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('viewAvailability.lastname')">{{ $t('El campo apellido es requerido') }}</span>
                      </div>
                      <div class="form-group col-12 col-lg-4">
                        <label>{{ $t('Teléfono').toUpperCase() }} *</label>
                        <masked-input v-model="viewAvailability.phone" mask="(111) 111-1111" type="tel" name="viewAvailability.phone" v-validate="'required'" class="form-control form-control-lg"/>
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="viewAvailability.submitted && errors.has('viewAvailability.phone')">{{ $t('El campo teléfono es requerido') }}</span>
                      </div>
                      <div class="form-group col-12 col-lg-4">
                        <label>{{ $t('Correo Electrónico').toUpperCase() }}</label>
                        <input v-model="viewAvailability.email" name="viewAvailability.email" v-validate="'required'" type="text" class="form-control form-control-lg">
                      </div>
                      <div class="form-group col-12 col-lg-8">
                        <label>{{ $t('INTERESADO EN') }}</label>
                        <input v-model="viewAvailability.vehicle" name="viewAvailability.vehicle" v-validate="'required'" type="text" class="form-control form-control-lg" disabled>
                      </div>
                      <div class="form-group col-12 col-lg-12">
                        <label>{{ $t('MENSAJE') }}</label>
                        <textarea v-model="viewAvailability.message" name="viewAvailability.message" v-validate="'required'" class="form-control form-control-lg" rows="1"></textarea>
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('viewAvailability.message')">{{ $t('El campo mensaje es requerido') }}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12">
                        <div class="captcha formBorder">
                          <h3 class="formElement">{{ $t('Comprobar que eres humano') }}:</h3>
                          <label><input v-model="viewAvailability.human" name="viewAvailability.human" v-validate="'required'" type="checkbox"> {{ $t('Marcar esta casilla para corroborar que es humano') }}</label>
                            <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('viewAvailability.human')">{{ $t('Debes confirmar que eres humano') }}</span>
                        </div>
                      </div>
                      <div class="col-12">
                        <p class="text-success" v-if="viewAvailability.responseMessage">{{ $t(viewAvailability.responseMessage) }}.</p>
                        <button type="submit" class="btn btn-primary i-lg formBackgroundBorder"><i class="icon-send mr-2"></i>
                          <strong>{{ $t('Enviar') }}</strong></button>
                      </div>
                    </div>
                  </form>
                  <form id="finance-tab" :class="{ tab: true, 'd-block': currentTabID == 'finance-tab' }" v-on:submit.prevent="validateForm('financingForm')" data-vv-scope="financingForm">
                    <h2 class="title text-center text-uppercase my-4 beforeBorderTop">{{ $t('POR FAVOR LLENE SU INFORMACIÓN') }}:</h2>
                    <div class="row">
                      <h5 class="col-12 mb-3 formElement">{{ $t('Información de contacto') }}:</h5>
                      <div class="form-group col-12 col-md-4">
                        <label>{{ $t('Nombre').toUpperCase() }} *</label>
                        <input v-model="financing.name" name="financingForm.name" v-validate="'required'" class="form-control form-control-lg" type="text">
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.name')">{{ $t('El campo nombre es requerido') }}</span>
                      </div>
                      <div class="form-group col-12 col-md-4">
                        <label>{{ $t('Apellido').toUpperCase() }} *</label>
                        <input v-model="financing.lastname" name="financingForm.lastname" v-validate="'required'" class="form-control form-control-lg" type="text">
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.lastname')">{{ $t('El campo apellido es requerido') }}</span>
                      </div>
                      <div class="form-group col-12 col-md-4">
                        <label>{{ $t('Teléfono').toUpperCase() }} *</label>
                        <masked-input v-model="financing.phone" mask="(111) 111-1111" type="tel" name="financingForm.phone" v-validate="'required'" class="form-control form-control-lg"/>
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="financing.submitted && errors.has('financingForm.phone')">{{ $t('El campo teléfono es requerido') }}</span>
                      </div>
                      <div class="form-group col-12 col-md-4">
                        <label>{{ $t('Correo Electrónico').toUpperCase() }}</label>
                        <input v-model="financing.email" name="financingForm.email" v-validate="'email'" class="form-control form-control-lg" type="text">
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.email')">{{ $t('Formato incorrecto') }}</span>
                      </div>
                      <div class="form-group col-12 col-md-4">
                        <label>{{ $t('FECHA DE NACIMIENTO') }}</label>
                        <input v-model="financing.date" name="financingForm.date" class="form-control form-control-lg" type="date">
                      </div>
                      <div class="form-group col-12 col-md-4">
                        <label>{{ $t('ESTADO CIVIL') }} *</label>
                        <select v-model="financing.civilStatus" name="financingForm.civilStatus" v-validate="'required'" class="form-control form-control-lg">
                          <option selected disabled value="null">{{ $t('Seleccionar') }}</option>
                          <option value="single">{{ $t('Soltero(a)') }}</option>
                          <option value="married">{{ $t('Casado(a)') }}</option>
                        </select>
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.civilStatus')">{{ $t('El campo estado civil es requerido') }}</span>
                      </div>
                    </div>
                    <hr>
                    <div class="row">
                      <h5 class="col-12 mb-3 formElement">{{ $t('Información de vivienda') }}:</h5>
                      <div class="form-group col-12 col-md-4">
                        <label>{{ $t('DIRECCIÓN') }} *</label>
                        <input v-model="financing.address" name="financingForm.address" v-validate="'required'" class="form-control form-control-lg" type="text">
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.address')">{{ $t('El campo dirección es requerido') }}</span>
                      </div>
                      <div class="form-group col-12 col-md-4">
                        <label>{{ $t('URBANIZACIÓN') }}</label>
                        <input v-model="financing.urbanization" name="financingForm.urbanization" class="form-control form-control-lg" type="text">
                      </div>
                      <div class="form-group col-12 col-md-4">
                        <label>{{ $t('CIUDAD') }} *</label>
                        <input v-model="financing.city" name="financingForm.city" v-validate="'required'" class="form-control form-control-lg" type="text">
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.city')">{{ $t('El campo ciudad es requerido') }}</span>
                      </div>
                      <div class="form-group col-12 col-md-4">
                        <label>{{ $t('CÓDIGO POSTAL') }} *</label>
                        <input v-model="financing.zipcode" name="financingForm.zipcode" v-validate="'required'" maxlength="5" class="form-control form-control-lg" type="text">
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.zipcode')">{{ $t('El campo código postal es requerido') }}</span>
                      </div>
                    </div>
                    <hr>
                    <div class="row">
                      <h5 class="col-12 mb-3 formElement">{{ $t('Información financiera') }}:</h5>
                      <div class="form-group col-12 col-md-4">
                        <label>{{ $t('TIPO DE EMPLEO') }} *</label>
                        <select v-model="financing.jobType" name="financingForm.jobType" v-validate="'required'" class="form-control form-control-lg">
                          <option selected disabled value="null">{{ $t('Seleccionar') }}</option>
                          <option value="fullTime">{{ $t('Tiempo completo') }}</option>
                          <option value="partTime">{{ $t('Tiempo parcial') }}</option>
                          <option value="freelance">{{ $t('Por cuenta propia') }}</option>
                        </select>
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.jobType')">{{ $t('El campo tipo de empleo es requerido') }}</span>
                      </div>
                      <div class="form-group col-12 col-md-4">
                        <label>{{ $t('SUELDO MENSUAL') }} *</label>
                        <input v-model="financing.salary" name="financingForm.salary" v-validate="'required'" class="form-control form-control-lg" type="text">
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.salary')">{{ $t('El campo salario es requerido') }}</span>
                      </div>
                      <div class="form-group col-12 col-md-4">
                        <label>{{ $t('DUEÑO DE RESIDENCIA') }}</label>
                        <select v-model="financing.residenceType" name="financingForm.residenceType" class="form-control form-control-lg">
                          <option selected disabled value="null">{{ $t('Seleccionar') }}</option>
                          <option value="rent">{{ $t('Alquilar') }}</option>
                          <option value="owner">{{ $t('Propia') }}</option>
                          <option value="family">{{ $t('Familiar') }}</option>
                        </select>
                      </div>
                      <div class="form-group col-12 col-md-4">
                        <label>{{ $t('PAGO DE RESIDENCIA') }}</label>
                        <input v-model="financing.residencePayment" name="financingForm.residencePayment" class="form-control form-control-lg" type="text">
                      </div>
                      <div class="form-group col-12 col-md-4">
                        <label><img src="/img/httpssecured.png" alt="Https Secured Icon" style="height: 22px; width: 22px;" class="mr-1">{{ $t('SEGURIDAD SOCIAL') }}*</label>
                        <input v-model="financing.socialSecurity" name="financingForm.socialSecurity" v-validate="'required'" class="form-control form-control-lg" type="text">
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.socialSecurity')">{{ $t('El campo seguridad social es requerido') }}</span>
                      </div>
                    </div>
                    <hr>
                    <div class="row">
                      <h5 class="col-12 mb-3 formElement">{{ $t('Información del vehículo') }}:</h5>
                      <div class="form-group col-12 col-md-4">
                        <label>{{ $t('VEHÍCULO QUE BUSCA') }} *</label>
                        <input v-model="financing.vehicle" name="financingForm.vehicle" v-validate="'required'" class="form-control form-control-lg" type="text">
                        <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.vehicle')">{{ $t('El campo vehículo es requerido') }}</span>
                      </div>
                    </div>
                    <hr>
                    <div class="row">
                      <div class="form-group col-12">
                        <div class="captcha formBorder">
                          <h3 class="formElement">{{ $t('Comprobar que eres humano') }}:</h3>
                          <label><input v-model="financing.human" name="financingForm.human" v-validate="'required'" type="checkbox"> {{ $t('Marcar esta casilla para corroborar que es humano') }}</label>
                          <span class="text-danger small mb-3 d-block fix-margin" v-if="errors.has('financingForm.human')">{{ $t('Debes confirmar que eres humano') }}</span>
                        </div>
                      </div>
                      <div class="col-12">
                        <p class="text-success" v-if="financing.responseMessage">{{ $t(financing.responseMessage) }}.</p>
                        <button class="btn btn-primary formBackgroundBorder"><i class="icon-send"></i> {{ $t('Enviar') }}</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </section>
              <hr>
              <div class="mt-3 mb-5">
                <h2 class="title text-center text-uppercase my-4 beforeBorderTop">{{ $t('UBICACIÓN DEL VEHÍCULO') }}:</h2>
                <div class="row contact-block">
                  <div class="col-12 col-lg mb-3">
                    <div class="map-holder">
                      <div class="embed-responsive embed-responsive-21by9">
                        <iframe class="embed-responsive-item" :src="`https://maps.google.com/maps?q=${gettingRooftop.lat ? gettingRooftop.lat : gettingDealerGroup.lat},${gettingRooftop.long ? gettingRooftop.long : gettingDealerGroup.long}&hl=es;z=14&amp;output=embed`"></iframe>
                      </div>
                      <a class="zoom buttonBackgroundBorder" :href="gettingRooftop.map_url" target="_blank"><i class="icon-expand"></i></a>
                    </div>
                  </div>
                  <div class="col-12 col-lg-4">
                    <h2 class="buttonElement">{{ gettingRooftop.name ? gettingRooftop.name : gettingDealerGroup.name }}</h2>
                    <address>
                      <strong>{{ $t('Dirección Física') }}:</strong> <br>
                      <a :href="gettingRooftop.map_url ? gettingRooftop.map_url : gettingDealerGroup.map_url" target="_blank" class="hoverElement buttonElement">{{ gettingRooftop.address ? gettingRooftop.address : gettingDealerGroup.address }}</a>
                    </address>
                  </div>
                  <div class="col-12 col-lg-4">
                    <div class="row">
                      <div class="col-12 col-xl-auto p-xl-1 mb-2" >
                        <a href="javascript:;" @click="setTabID('finance-tab')" v-scroll-to="{ el: '#finance-tab', offset: -180 }" class="btn btn-block btn-primary i-lg buttonBackgroundBorder">
                          <i class="icon-finance mr-2"></i>{{ $t('Financiamiento') }}
                        </a>
                      </div>
                      <div class="col-12 col-xl-auto p-xl-1 mb-2">
                        <a href="javascript:;" @click="goToTab('trade-tab');" class="btn btn-block btn-primary i-lg buttonBackgroundBorder">
                          <i class="icon-trade-in mr-2"></i>Trade-in
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <NavFloating></NavFloating>
    </main>
    <div class="print-box" v-if="vehicle && this.$route.query.print === 'true'">
      <div class="header">
        <span class="img-user">
          <img :src="seller.photo_url" class="img-fluid">
        </span>
        <address>
          <h6><strong>{{ seller.first_name }} {{ seller.last_name }}</strong></h6>
          <h6>{{ seller.professional_title }}</h6>
          <p>Cel: <a :href="`tel:1${seller.phone}`"> {{ seller.phone }} </a></p>
          <p>{{ $t('Correo Electrónico') }}: <a :href="`mailto:${seller.email}`"> {{ seller.email }} </a></p>
        </address>
        <address>
          <h6><strong> {{ sharedData.name }}</strong></h6>
          <p>{{ $t('Teléfono') }}: <a :href="`tel:1${sharedData.phone}`"> {{ sharedData.phone }}</a></p>
          <p>{{ $t('Dirección') }}: <a :href="sharedData.addressLink" target="_blank"> {{ sharedData.address }} </a></p>
        </address>
      </div>
      <div class="main">
        <div class="img-box">
          <h5>{{ vehicle.make }} {{ vehicle.model }} {{ vehicle.year }}</h5>
          <img :src="`${vehicle.photos[0] ? vehicle.photos[0].url : '/img/placeholder-vehicle.jpg'}`" class="img-fluid">
        </div>
        <div class="info-cart">
          <p>VIN#:<span> {{ vehicle.vin }}</span></p>
          <p>Stock#:<span> {{ vehicle.stock_number }}</span></p>
          <p>{{ $t('Transmisión') }}:<span> {{ vehicle.transmission_description }}</span></p>
          <p>{{ $t('Color Exterior') }}:<span> {{ vehicle.exterior_generic_color }}</span></p>
          <p>{{ $t('Millaje') }}:<span> {{ vehicle.mileage|numFormat }}</span></p>
          <p>{{ $t('Descripción') }}: <br>
            <span v-html="vehicle.description"></span>
          </p>
          <div class="rpm">
            <p>{{ $t('Autopista') }}: <span>{{ vehicle.highway_miles_per_gallon }}</span></p>
            <p>{{ $t('Ciudad') }}: <span>{{ vehicle.city_miles_per_gallon }}</span></p>
          </div>
          <h5>{{ $t('Precio') }}: {{ vehiclePrice ? `$${vehiclePrice}` : `${$t('Llame Ahora')}` }}{{ vehicle.selling_price.payment.value ? ` | $${vehicle.selling_price.payment.value|numFormat}` : '' }}<span></span></h5>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 col-lg-6">
          <ul class="list-category">
            <li>
              <h6>{{ $t('Seguridad').toUpperCase() }}:</h6>
              <ul>
                <li v-for="(equipment, index) in equipments.safety" :key="index">{{ equipment.description }}</li>
              </ul>
            </li>
            <li>
              <h6>{{ $t('Exterior').toUpperCase() }}:</h6>
              <ul>
                <li v-for="(equipment, index) in equipments.exterior" :key="index">{{ equipment.description }}</li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="col-12 col-md-6 col-lg-6">
          <ul class="list-category">
            <li>
              <h6>{{ $t('Interior').toUpperCase() }}:</h6>
              <ul>
                <li v-for="(equipment, index) in equipments.interior" :key="index">{{ equipment.description }}</li>
              </ul>
            </li>
            <li>
              <h6>{{ $t('Mecánica').toUpperCase() }}:</h6>
              <ul>
                <li v-for="(equipment, index) in equipments.mechanical" :key="index">{{ equipment.description }}</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'flickity-fullscreen';
import MaskedInput from 'vue-masked-input';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  name: 'vehicle-detail',
  components: {
    Loading,
    NavFloating: () => import('@/components/NavFloating.vue'),
    Flickity: () => import('vue-flickity'),
    MaskedInput,
    flatPickr,
  },
  data() {
    return {
      seller: {},
      // Vehicle data
      vehicle: null,
      vehiclePrice: null,
      rooftop: null,
      // Forms
      testDrive: {
        name: null,
        lastname: null,
        phone: null,
        email: null,
        datetime: null,
        vehicle: null,
        message: null,
        human: null,
        responseMessage: null,
        submitted: false,
      },
      viewAvailability: {
        name: null,
        lastname: null,
        phone: null,
        email: null,
        vehicle: null,
        message: null,
        human: null,
        responseMessage: null,
        submitted: false,
      },
      financing: {
        name: null,
        lastname: null,
        phone: null,
        email: null,
        date: null,
        civilStatus: null,
        address: null,
        urbanization: null,
        city: null,
        zipcode: null,
        jobType: null,
        salary: null,
        residenceType: null,
        residencePayment: null,
        socialSecurity: null,
        vehicle: null,
        human: null,
        responseMessage: null,
        submitted: false,
      },
      tabID: 'schedule-testdrive',
      // Equipments
      equipments: {
        mechanical: [],
        safety: [],
        exterior: [],
        interior: [],
        entertainment: [],
        specs: [],
        installed: [],
        miscellaneous: [],
      },
      // Flickity related
      flickityOptions: {
        pageDots: false,
        lazyLoad: true,
        fullscreen: false,
      },
      galleryIndex: 0,
      isLoading: true,
      config: {
        dateFormat: 'd-m-Y H:i',
        enableTime: true,
      },
    };
  },
  watch: {
    vehicle(newVal, oldVal) {
      console.log(oldVal, newVal);
      if (oldVal === null) {
        this.$gtag.event('LandingVehicleView', {
          event_category: this.seller.email,
          event_label: this.vehicle.vin,
        });
      }
    },
  },
  methods: {
    ...mapActions([
      'requestVehicle',
      'requestRooftop',
      'getColorScheme',
    ]),
    ...mapMutations(['setTabID']),
    galleryThumb(index) {
      this.$refs.flickity.select(index);
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        this.testDrive.submitted = scope === 'testDrive';
        this.viewAvailability.submitted = scope === 'viewAvailability';
        this.financing.submitted = scope === 'financingForm';
        if (result && scope === 'testDrive') {
          const formData = new FormData();
          formData.append('name', this.testDrive.name);
          formData.append('lastname', this.testDrive.lastname);
          formData.append('phone', this.testDrive.phone);
          formData.append('email', this.testDrive.email);
          formData.append('date', this.testDrive.datetime);
          formData.append('vehicleid', this.vehicle.id);
          formData.append('message', this.testDrive.message);
          formData.append('username', this.$route.params.username);
          this.$axios.post(`${process.env.VUE_APP_SELLERS_API_URL}/forms/testdrive`, formData).then((response) => {
            this.testDrive.responseMessage = response.data;
          });
        }
        if (result && scope === 'viewAvailability') {
          const formData = new FormData();
          formData.append('name', this.viewAvailability.name);
          formData.append('lastname', this.viewAvailability.lastname);
          formData.append('phone', this.viewAvailability.phone);
          formData.append('email', this.viewAvailability.email);
          formData.append('vehicleid', this.vehicle.id);
          formData.append('message', this.viewAvailability.message);
          formData.append('username', this.$route.params.username);
          this.$axios.post(`${process.env.VUE_APP_SELLERS_API_URL}/forms/vehicleinterest`, formData).then((response) => {
            this.viewAvailability.responseMessage = response.data;
          });
        }
        if (result && scope === 'financingForm') {
          const formData = new FormData();
          formData.append('name', this.financing.name);
          formData.append('lastname', this.financing.lastname);
          formData.append('phone', this.financing.phone);
          formData.append('email', this.financing.email);
          formData.append('birthdate', this.financing.date);
          formData.append('civilstatus', this.financing.civilStatus);
          formData.append('address', this.financing.address);
          formData.append('urbanization', this.financing.urbanization);
          formData.append('city', this.financing.city);
          formData.append('postalcode', this.financing.zipcode);
          formData.append('employment_type', this.financing.jobType);
          formData.append('monthly_income', this.financing.salary);
          formData.append('residence_owner', this.financing.residenceType);
          formData.append('residence_payment', this.financing.residencePayment);
          formData.append('social_security', this.financing.socialSecurity);
          formData.append('vehicleinfo', this.financing.vehicle);
          formData.append('username', this.$route.params.username);
          this.$axios.post(`${process.env.VUE_APP_SELLERS_API_URL}/forms/financing`, formData).then((response) => {
            this.financing.responseMessage = response.data;
          });
        }
      });
    },
    applyCSS(colorScheme) {
      const nodeId = 'vue-style-hack-vehicle';
      let style = document.getElementById(nodeId);
      if (!style) {
        style = document.createElement('style');
        style.id = nodeId;
        style.type = 'text/css';
        this.$el.appendChild(style);
      }
      if (colorScheme && colorScheme.accent) {
        const cssRule = `.flickity-button { background-color: ${colorScheme.accent}!important; }`;
        style.innerHTML = cssRule;
      }
    },
    printPage() {
      window.open(`${this.$route.fullPath}?print=true`, '_blank');
    },
    goBack(hashID = null) {
      const user = this.$route.params.username;
      this.$router.push({
        name: 'home',
        hash: hashID,
        params: { user },
        query: { redirecting: 'home' },
      });
    },
    goToTab(tabID) {
      const user = this.$route.params.username;
      this.setTabID(tabID);
      this.$router.push({ name: 'home', hash: `#${tabID}`, params: { user } });
    },
    changeTabID(tabID) {
      this.setTabID(tabID);
    },
    scrollTo(tabID) {
      let id = tabID.substring(1);
      Promise.all([this.setTabID(id)]).then(() => {
        id = tabID === 'finance-tab' || tabID === 'view-availability' ? 'schedule-testdrive' : tabID;
        this.$scrollTo(id, 1000, { offset: -180 });
      });
    },
  },
  computed: {
    sharedData() {
      return this.$store.getters.getSharedData;
    },
    gettingRooftop() {
      return this.$store.getters.getRooftop;
    },
    gettingDealerGroup() {
      return this.$store.getters.getDealerGroup;
    },
    currentTabID() {
      return this.$store.getters.getTabID;
    },
  },
  created() {
    this.seller = this.$store.getters.getProfile;
    setTimeout(() => {
      this.applyCSS(this.$store.getters.getColorScheme);
      this.isLoading = false;
    }, 1000);
    // Getting vehicle details
    this.requestVehicle(this.$route.params.slug).then((response) => {
      this.vehicle = response;
      if (this.vehicle.selling_price.price.value) {
        this.vehiclePrice = this.vehicle.selling_price.price.value;
      } else if (!this.vehicle.selling_price.price.value && this.vehicle.selling_price.range.value) {
        this.vehiclePrice = this.vehicle.selling_price.range.value;
      }
      const vinFinalDigits = this.vehicle.vin.substr(this.vehicle.vin.length - 6);
      this.testDrive.vehicle = `${this.vehicle.make} ${this.vehicle.model} ${this.vehicle.exterior_generic_color} ${this.vehicle.year} VIN#${vinFinalDigits}`;
      this.viewAvailability.vehicle = this.testDrive.vehicle;
      this.financing.vehicle = this.testDrive.vehicle;
      // this.requestRooftop(this.vehicle.rooftop.id).then((rooftop) => {
      //   this.rooftop = rooftop;
      // });
      response.equipments.forEach((element) => {
        switch (element.category) {
          case 1: this.equipments.exterior.push(element); break;
          case 2: this.equipments.interior.push(element); break;
          case 3: this.equipments.mechanical.push(element); break;
          case 4: this.equipments.safety.push(element); break;
          case 5: this.equipments.installed.push(element); break;
          case 6: this.equipments.miscellaneous.push(element); break;
          case 7: this.equipments.entertainment.push(element); break;
          case 8: this.equipments.specs.push(element); break;
          default:
        }
      });
      if (this.vehicle.photos.length > 0) {
        setTimeout(() => { this.$refs.flickity.on('change', (event) => { this.galleryIndex = event; }); }, 1000);
      }
    });
  },
  mounted() {
    window.addEventListener('unload', this.someMethod);
    if (this.$route.hash) setTimeout(() => { this.$scrollTo(this.$route.hash, 500, { offset: -180 }); }, 1000);
  },
};
</script>
